import React from 'react';
import ReactDOM from 'react-dom/client';
import AskHenry from './AskHenry';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AskHenry />
  </React.StrictMode>
);
/*
  <React.StrictMode>
    <AskHenry />
  </React.StrictMode>
*/